/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RichtextFacet from '../richtext/facet.defs.js'
import * as EmbedImages from '../embed/images.defs.js'
import * as EmbedVideo from '../embed/video.defs.js'
import * as EmbedExternal from '../embed/external.defs.js'
import * as EmbedRecord from '../embed/record.defs.js'
import * as EmbedRecordWithMedia from '../embed/recordWithMedia.defs.js'
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs.js'

const $nsid = 'app.bsky.feed.post'

export { $nsid }

/** Record containing a Bluesky post. */
type Main = {
  $type: 'app.bsky.feed.post'

  /**
   * The primary post content. May be an empty string, if there are embeds.
   */
  text: string

  /**
   * @deprecated replaced by app.bsky.richtext.facet.
   */
  entities?: Entity[]

  /**
   * Annotations of text (mentions, URLs, hashtags, etc)
   */
  facets?: RichtextFacet.Main[]
  reply?: ReplyRef
  embed?:
    | l.$Typed<EmbedImages.Main>
    | l.$Typed<EmbedVideo.Main>
    | l.$Typed<EmbedExternal.Main>
    | l.$Typed<EmbedRecord.Main>
    | l.$Typed<EmbedRecordWithMedia.Main>
    | l.Unknown$TypedObject

  /**
   * Indicates human language of post primary text content.
   */
  langs?: l.LanguageString[]

  /**
   * Self-label values for this post. Effectively content warnings.
   */
  labels?: l.$Typed<LabelDefs.SelfLabels> | l.Unknown$TypedObject

  /**
   * Additional hashtags, in addition to any included in post text and facets.
   */
  tags?: string[]

  /**
   * Client-declared timestamp when this post was originally created.
   */
  createdAt: l.DatetimeString
}

export type { Main }

/** Record containing a Bluesky post. */
const main = l.record<'tid', Main>(
  'tid',
  $nsid,
  l.object({
    text: l.string({ maxLength: 3000, maxGraphemes: 300 }),
    entities: l.optional(l.array(l.ref<Entity>((() => entity) as any))),
    facets: l.optional(
      l.array(l.ref<RichtextFacet.Main>((() => RichtextFacet.main) as any)),
    ),
    reply: l.optional(l.ref<ReplyRef>((() => replyRef) as any)),
    embed: l.optional(
      l.typedUnion(
        [
          l.typedRef<EmbedImages.Main>((() => EmbedImages.main) as any),
          l.typedRef<EmbedVideo.Main>((() => EmbedVideo.main) as any),
          l.typedRef<EmbedExternal.Main>((() => EmbedExternal.main) as any),
          l.typedRef<EmbedRecord.Main>((() => EmbedRecord.main) as any),
          l.typedRef<EmbedRecordWithMedia.Main>(
            (() => EmbedRecordWithMedia.main) as any,
          ),
        ],
        false,
      ),
    ),
    langs: l.optional(
      l.array(l.string({ format: 'language' }), { maxLength: 3 }),
    ),
    labels: l.optional(
      l.typedUnion(
        [l.typedRef<LabelDefs.SelfLabels>((() => LabelDefs.selfLabels) as any)],
        false,
      ),
    ),
    tags: l.optional(
      l.array(l.string({ maxLength: 640, maxGraphemes: 64 }), { maxLength: 8 }),
    ),
    createdAt: l.string({ format: 'datetime' }),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type ReplyRef = {
  $type?: 'app.bsky.feed.post#replyRef'
  root: RepoStrongRef.Main
  parent: RepoStrongRef.Main
}

export type { ReplyRef }

const replyRef = l.typedObject<ReplyRef>(
  $nsid,
  'replyRef',
  l.object({
    root: l.ref<RepoStrongRef.Main>((() => RepoStrongRef.main) as any),
    parent: l.ref<RepoStrongRef.Main>((() => RepoStrongRef.main) as any),
  }),
)

export { replyRef }

/** @deprecated use facets instead. */
type Entity = {
  $type?: 'app.bsky.feed.post#entity'
  index: TextSlice

  /**
   * Expected values are 'mention' and 'link'.
   */
  type: string
  value: string
}

export type { Entity }

/** @deprecated use facets instead. */
const entity = l.typedObject<Entity>(
  $nsid,
  'entity',
  l.object({
    index: l.ref<TextSlice>((() => textSlice) as any),
    type: l.string(),
    value: l.string(),
  }),
)

export { entity }

/**
 * A text segment. Start is inclusive, end is exclusive. Indices are for utf16-encoded strings.
 * @deprecated . Use app.bsky.richtext instead
 */
type TextSlice = {
  $type?: 'app.bsky.feed.post#textSlice'
  start: number
  end: number
}

export type { TextSlice }

/**
 * A text segment. Start is inclusive, end is exclusive. Indices are for utf16-encoded strings.
 * @deprecated . Use app.bsky.richtext instead
 */
const textSlice = l.typedObject<TextSlice>(
  $nsid,
  'textSlice',
  l.object({
    start: l.integer({ minimum: 0 }),
    end: l.integer({ minimum: 0 }),
  }),
)

export { textSlice }
